import React, { useEffect, useRef, useState } from "react";
import { Card, Container, Row, Col, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useHistory } from "react-router";
import moment from "moment";
import { useFormik } from "formik";
import * as Yup from "yup";

import {
  editUserProfile,
  getUserProfileAddress,
  updateUserAddress,
} from "../../Store/actions";

export default function Profile() {
  const { currentUser } = useSelector((state) => state.Auth);
  const { userProfileAddress } = useSelector((state) => state.Profile);
  const imgRef = useRef();
  const [addressState, setAddressState] = useState({
    countries: [],
    states: [],
    areas: [],
    filterdStates: [],
    filterdAreas: [],
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const initialValues = {
    dealership_type: "",
    company_name: "",
    ssm_number: "",
    phone: "",
    email: "",
    line_1: "",
    line_2: "",
    postcode: "",
    area_id: "",
    state_id: "",
    country_id: "",
    username: "",
    profile_picture: null,
  };

  const imgChangeHandler = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      formik.setFieldValue("profile_picture", reader.result);
    };
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      dealership_type: Yup.string().required("dealership is required"),
      company_name: Yup.string().required("companry name is required"),
      ssm_number: Yup.string().required("ssm number is required"),
      phone: Yup.string().required("ssm number is required"),
      email: Yup.string().required("ssm number is required"),
      line_1: Yup.string().required("ssm number is required"),
      line_2: Yup.string().required("ssm number is required"),
      postcode: Yup.string().required("ssm number is required"),
      area_id: Yup.string().required("ssm number is required"),
      state_id: Yup.string().required("ssm number is required"),
      country_id: Yup.string().required("ssm number is required"),
      username: Yup.string().required("ssm number is required"),
    }),
    onSubmit: (values) => {
      const data = {
        dealership_type: values.dealership_type,
        company_name: values.company_name,
        ssm_number: values.ssm_number,
        phone: values.phone,
        email: values.email,
        username: values.username,
        profile_picture: values.profile_picture,
      };

      const areaName = addressState.areas.filter(
        (area) => +area.id === +values.area_id
      )[0];
      const stateName = addressState.states.filter(
        (state) => +state.id === +values.state_id
      )[0];

      const addresData = {
        id: values.id,
        line_1: values.line_1,
        line_2: values.line_2,
        postcode: values.postcode,
        area: areaName.name,
        state: stateName.name,
        country_id: +values.country_id,
      };
      if (data.profile_picture === null) delete data.profile_picture;
      // console.log(addresData);
      dispatch(editUserProfile(data));
      dispatch(updateUserAddress(addresData));
    },
  });

  const { setValues } = formik;

  useEffect(() => {
    dispatch(getUserProfileAddress(localStorage.getItem("idToken")));
    axios
      .get(`countries`)
      .then((response) => {
        setAddressState((prev) => {
          return {
            ...prev,
            countries: response.data.data,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`states`)
      .then((response) => {
        setAddressState((prev) => {
          return {
            ...prev,
            states: response.data.data,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`areas`)
      .then((response) => {
        setAddressState((prev) => {
          return {
            ...prev,
            areas: response.data.data,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [dispatch]);

  useEffect(() => {
    if (currentUser && userProfileAddress && userProfileAddress[0]) {
      setValues({
        dealership_type: currentUser.dealership_type ?? "",
        company_name: currentUser.company_name ?? "",
        ssm_number: currentUser.ssm_number ?? "",
        phone: currentUser.phone ?? "",
        email: currentUser.email ?? "",
        username: currentUser.email ?? "",
        id: userProfileAddress[0].id ?? "",
        line_1: userProfileAddress[0].line_1 ?? "",
        line_2: userProfileAddress[0].line_2 ?? "",
        postcode: userProfileAddress[0].postcode ?? "",
        area_id: userProfileAddress[0].area_id ?? "",
        state_id: userProfileAddress[0].state_id ?? "",
        country_id: userProfileAddress[0].country_id ?? "",
        profile_picture: null,
      });
    }
  }, [currentUser, userProfileAddress, setValues]);

  //styles start
  const mainTile = {
    fontSize: "3.4rem",
    fontWeight: "bold",
    color: "#11141A",
  };

  const afterMainTile = {
    fontSize: "1.4rem",
    color: "#7F8FA4",
  };

  const formGroup = {
    position: "relative",
  };

  const formControl = {
    border: "2px solid #7F8FA4",
    borderRadius: "6px",
    color: "#707070",
    backgroundColor: "white",
    padding: "0.5rem",
  };
  const formLabel = {
    position: "absolute",
    top: "-15px",
    left: "25px",
    margin: "0",
    padding: "0 15px",
    zIndex: "100",
    color: "#7F8FA4",
    fontWeight: "bolder",
    backgroundColor: "white",
    whiteSpace: "nowrap",
    overflow: "hidden",
  };
  const formPlaceholder = {
    color: "#7F8FA4",
    fontSize: ".7rem",
  };
  //styles end

  return (
    <Container fluid className="py-3">
      <Row>
        <Col>
          <h1 style={mainTile}>Profile</h1>
          <h4 style={afterMainTile} className="mb-4">
            Change or edit your profile
          </h4>
        </Col>
      </Row>
      <Card
        className="d-none d-lg-block border-0 my-5"
        style={{ backgroundColor: "#32baa50d" }}
      >
        {currentUser && (
          <Card.Body>
            <Row>
              <Col lg={4} className="px-3 px-xl-4">
                <Row>
                  <Col>
                    <h6>Hello,</h6>
                    <h3>Dealer</h3>
                  </Col>
                  <Col>
                    <div
                      style={{
                        position: "relative",
                        paddingTop: "75px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={currentUser.profile_picture}
                        alt="seller"
                        className="rounded-circle"
                        width="75px"
                        height="75px"
                        style={{
                          position: "absolute",
                          top: "0",
                          right: "0",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="d-grid">
                    <Button
                      variant="primary"
                      className="text-white p-3 my-4 shadow-none"
                      style={{ borderRadius: "1rem" }}
                      onClick={(e) => history.push("/Feature")}
                    >
                      Become a Featured Dealer
                    </Button>
                  </Col>
                </Row>
              </Col>

              <Col lg={4} className="px-3 px-xl-4">
                <Card
                  className="border-0 shadow-sm"
                  style={{ borderRadius: "1rem" }}
                >
                  <Card.Body>
                    <Row>
                      <Col>
                        <p className="m-0 text-tertiary fw-bolder">Status</p>
                        <p className="m-0 text-tertiary fw-bolder">Active</p>
                      </Col>
                      <Col>
                        <p className="m-0 text-tertiary fw-bolder text-center">
                          Account type
                        </p>
                        <p className="m-0 text-tertiary fw-bolder text-center">
                          {currentUser.dealership_type}
                        </p>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col>
                        <p className="m-0 text-tertiary fw-bolder">
                          Token Balance
                        </p>
                        <p className="m-0 text-tertiary fw-bolder">
                          {currentUser.pcari_token_balance}
                          <small
                            style={{ fontSize: ".6rem" }}
                            className="ms-1 fw-bold"
                          >
                            TOKEN
                          </small>
                        </p>
                      </Col>
                      <Col className="d-flex justify-content-center align-items-center">
                        <Button
                          variant="outline-warning text-tertiary shadow-none"
                          onClick={(e) => history.push("/TopUp")}
                        >
                          TopUp
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={4} className="px-3 px-xl-4">
                <p
                  className="m-0 text-tertiary fw-bolder ps-4"
                  style={{ color: "#7F8FA4", fontSize: "1.3rem" }}
                >
                  Joined about
                  {" " + moment(currentUser.created_at, "YYYYMMDD").fromNow()}
                </p>
                <p
                  className="m-0 text-tertiary fw-bolder ps-4"
                  style={{ color: "#7F8FA4", fontSize: "1.3rem" }}
                >
                  Verified
                </p>
              </Col>
            </Row>
          </Card.Body>
        )}
      </Card>
      {currentUser && (
        <Card className="border-0 shadow-sm">
          <Card.Body>
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col md={6} lg={3}>
                  <Form.Group className="my-4">
                    <Form.Label>
                      <h2 className="my-3">Dealership</h2>
                    </Form.Label>
                    <Form.Check
                      type="radio"
                      className="text-tertiary fs-5 fw-bold mb-0"
                      label="Company"
                      name="dealership_type"
                      value={"company"}
                      checked={
                        formik.values.dealership_type.toLowerCase() ===
                        "company"
                      }
                      onChange={(e) =>
                        formik.setFieldValue("dealership_type", e.target.value)
                      }
                    />
                    <Form.Check
                      type="radio"
                      className="text-tertiary fs-5 fw-bold"
                      label="Private"
                      name="dealership_type"
                      value={"private"}
                      checked={
                        formik.values.dealership_type.toLowerCase() ===
                        "private"
                      }
                      onChange={(e) =>
                        formik.setFieldValue("dealership_type", e.target.value)
                      }
                    />
                  </Form.Group>

                  <Form.Group className="my-4" style={formGroup}>
                    <Form.Label style={formLabel}>Company Name</Form.Label>
                    <Form.Control
                      style={formControl}
                      placeholder="Your Company Name"
                      {...formik.getFieldProps("company_name")}
                      isInvalid={
                        formik.errors.company_name &&
                        formik.touched.company_name
                      }
                    />
                    <small style={formPlaceholder}>
                      IE : PCARI MOTORS SDN BHD
                    </small>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.company_name}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="my-4" style={formGroup}>
                    <Form.Label style={formLabel}>SSM Number</Form.Label>
                    <Form.Control
                      style={formControl}
                      placeholder="Your SSM Number"
                      {...formik.getFieldProps("ssm_number")}
                      isInvalid={
                        formik.errors.ssm_number && formik.touched.ssm_number
                      }
                    />
                    <small style={formPlaceholder}>
                      IE : PCARI MOTORS SDN BHD
                    </small>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.ssm_number}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={3}>
                  <Form.Group>
                    <div
                      style={{
                        position: "relative",
                        paddingTop: "125px",
                        overflow: "hidden",
                        width: "125px",
                        margin: "0 auto",
                      }}
                    >
                      <img
                        src={
                          formik.values.profile_picture ??
                          currentUser.profile_picture
                        }
                        alt="seller"
                        className="rounded-circle"
                        width="125px"
                        height="125px"
                        style={{
                          position: "absolute",
                          top: "0",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div className="d-flex justify-content-center mt-3 mb-2">
                      <Button
                        onClick={(e) => {
                          if (imgRef && imgRef.current) imgRef.current.click();
                        }}
                        className="border-0 shadow-none rounded-pill"
                        style={{
                          backgroundColor: "rgb(20 196 168 / 22%)",
                          color: "#354052",
                        }}
                      >
                        Change Picture
                      </Button>
                    </div>
                    <Form.Control
                      ref={imgRef}
                      style={formControl}
                      type="file"
                      onChange={imgChangeHandler}
                    />
                  </Form.Group>
                  <Form.Group style={formGroup}>
                    <Form.Label style={formLabel}>User Name</Form.Label>
                    <Form.Control
                      style={{
                        ...formControl,
                        marginTop: "2.9rem",
                      }}
                      placeholder="Address User Name"
                      {...formik.getFieldProps("username")}
                      isInvalid={
                        formik.errors.username && formik.touched.username
                      }
                    />
                    <small style={formPlaceholder}>IE : 11000, </small>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.username}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={3}>
                  <Form.Group className="my-4" style={formGroup}>
                    <Form.Label style={formLabel}>Phone Number</Form.Label>
                    <Form.Control
                      style={formControl}
                      placeholder="Your Phone Number"
                      {...formik.getFieldProps("phone")}
                      isInvalid={formik.errors.phone && formik.touched.phone}
                    />
                    <small style={formPlaceholder}>IE : +60 11223344</small>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.phone}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="my-4" style={formGroup}>
                    <Form.Label style={formLabel}>Email</Form.Label>
                    <Form.Control
                      style={formControl}
                      value={formik.values.email}
                      readOnly
                    />
                  </Form.Group>

                  <Form.Group className="my-4" style={formGroup}>
                    <Form.Label style={formLabel}>Address Line 1</Form.Label>
                    <Form.Control
                      style={formControl}
                      placeholder="Address Line 1"
                      {...formik.getFieldProps("line_1")}
                      isInvalid={formik.errors.line_1 && formik.touched.line_1}
                    />
                    <small style={formPlaceholder}>IE : No.1 New Street,</small>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.line_1}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="my-4" style={formGroup}>
                    <Form.Label style={formLabel}>Address Line 2</Form.Label>
                    <Form.Control
                      style={formControl}
                      placeholder="Address Line 2"
                      {...formik.getFieldProps("line_2")}
                      isInvalid={formik.errors.line_2 && formik.touched.line_2}
                    />
                    <small style={formPlaceholder}>IE : New Valley, </small>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.line_2}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={3}>
                  <Form.Group className="my-4" style={formGroup}>
                    <Form.Label style={formLabel}>Post Code</Form.Label>
                    <Form.Control
                      style={formControl}
                      placeholder="Address Post Code"
                      {...formik.getFieldProps("postcode")}
                      isInvalid={
                        formik.errors.postcode && formik.touched.postcode
                      }
                    />
                    <small style={formPlaceholder}>IE : 11000, </small>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.postcode}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="my-4" style={formGroup}>
                    <Form.Label style={formLabel}>Area</Form.Label>
                    <Form.Control
                      style={formControl}
                      as="select"
                      value={formik.values.area_id}
                      onChange={(e) =>
                        formik.setFieldValue("area_id", e.target.value)
                      }
                    >
                      {addressState.areas.map(
                        (area) =>
                          +area.state_id === +formik.values.state_id && (
                            <option key={area.id} value={area.id}>
                              {area.name}
                            </option>
                          )
                      )}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.area_id}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="my-4" style={formGroup}>
                    <Form.Label style={formLabel}>State</Form.Label>
                    <Form.Control
                      style={formControl}
                      as="select"
                      value={formik.values.state_id}
                      onChange={(e) =>
                        formik.setFieldValue("state_id", e.target.value)
                      }
                    >
                      {addressState.states.map((state) => (
                        <option key={state.id} value={state.id}>
                          {state.name}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.state_id}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="my-4 mt-5" style={formGroup}>
                    <Form.Label style={formLabel}>Country</Form.Label>
                    <Form.Control
                      style={formControl}
                      as="select"
                      value={formik.values.country_id}
                      onChange={(e) =>
                        formik.setFieldValue("country_id", e.target.value)
                      }
                    >
                      {addressState.countries.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.state_id}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col
                  md={{ span: 6, offset: 6 }}
                  lg={{ span: 4, offset: 8 }}
                  xl={{ span: 3, offset: 9 }}
                  className="d-grid"
                >
                  <Button
                    variant="primary"
                    className="text-white rounded-pill"
                    type="submit"
                  >
                    Save Changes
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
}
